<nz-spin [nzSpinning]="loading$ | async">
  <form nz-form class="form" [formGroup]="dataLogsFilterForm">
    <div class="drawer-form-wrapper">
      <div class="form-grid-secondary">
        <nz-form-item>
          <nz-form-label nzFor="type">Action Type</nz-form-label>
          <nz-form-control>
            <nz-select
              nzSuffixIcon
              nzShowSearch
              nzAllowClear
              nzPlaceHolder="Select type"
              [nzOptionOverflowSize]="7"
              formControlName="dataAuditTypeId">
              @for (type of auditTypeList; track type) {
                <nz-option
                  [nzLabel]="type.value"
                  [nzValue]="type.id"></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="dataUnitType">Unit Type</nz-form-label>
          <nz-form-control>
            <nz-select
              nzSuffixIcon
              nzShowSearch
              nzAllowClear
              nzPlaceHolder="Select type"
              [nzOptionOverflowSize]="7"
              formControlName="dataUnitType">
              @for (type of UnitTypeList; track type) {
                <nz-option
                  [nzLabel]="type.value"
                  [nzValue]="type.value"></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
        <!-- <nz-form-item>
            <nz-form-label nzFor="user">User</nz-form-label>
            <nz-form-control>
              <nz-select
                nzSuffixIcon
                nzShowSearch
                nzAllowClear
                nzPlaceHolder="Select user"
                [nzOptionOverflowSize]="7"
                formControlName="userId">
                @for (user of userList; track user) {
                  <nz-option
                    [nzLabel]="user.userName"
                    [nzValue]="user.id"></nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item> -->
        <nz-form-item>
          <nz-form-label nzFor="startDataDate">Start Data Date</nz-form-label>
          <nz-form-control>
            <nz-date-picker
              [nzSuffixIcon]="customSuffix"
              nzPlaceHolder="Select Date"
              class="with-suffix"
              formControlName="startDataDateRange"
              (ngModelChange)="
                validateDates('startDataDateRange', 'endDataDateRange')
              "
              nzFormat="MM/dd/yyyy"></nz-date-picker>
            <ng-template #customSuffix>
              <svg-icon
                [title]="'Select Date'"
                src="/assets/icon/icon-calendar.svg"
                class="icon s-16"></svg-icon>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="endDataDate">End Data Date</nz-form-label>
          <nz-form-control>
            <nz-date-picker
              [nzSuffixIcon]="customSuffix"
              nzPlaceHolder="Select Date"
              class="with-suffix"
              formControlName="endDataDateRange"
              (ngModelChange)="
                validateDates('startDataDateRange', 'endDataDateRange')
              "
              nzFormat="MM/dd/yyyy"></nz-date-picker>
            <ng-template #customSuffix>
              <svg-icon
                [title]="'Select Date'"
                src="/assets/icon/icon-calendar.svg"
                class="icon s-16"></svg-icon>
            </ng-template>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label nzFor="startDate">Start Date</nz-form-label>
          <nz-form-control>
            <nz-date-picker
              [nzSuffixIcon]="customSuffix"
              nzPlaceHolder="Select Date"
              class="with-suffix"
              formControlName="startDateRange"
              (ngModelChange)="validateDates('startDateRange', 'endDateRange')"
              nzFormat="MM/dd/yyyy"></nz-date-picker>
            <ng-template #customSuffix>
              <svg-icon
                [title]="'Select Date'"
                src="/assets/icon/icon-calendar.svg"
                class="icon s-16"></svg-icon>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="endDate">End Date</nz-form-label>
          <nz-form-control>
            <nz-date-picker
              [nzSuffixIcon]="customSuffix"
              nzPlaceHolder="Select Date"
              class="with-suffix"
              formControlName="endDateRange"
              (ngModelChange)="validateDates('startDateRange', 'endDateRange')"
              nzFormat="MM/dd/yyyy"></nz-date-picker>
            <ng-template #customSuffix>
              <svg-icon
                [title]="'Select Date'"
                src="/assets/icon/icon-calendar.svg"
                class="icon s-16"></svg-icon>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <p
          class="error-text mb-24"
          *ngIf="
            dataLogsFilterForm.controls?.['startDateRange']?.errors?.[
              'dateInvalid'
            ] ||
            dataLogsFilterForm.controls?.['endDateRange']?.errors?.[
              'dateInvalid'
            ]
          ">
          Start date cannot be greater than end date.
        </p>
        <p
          class="error-text mb-24"
          *ngIf="
            dataLogsFilterForm.controls?.['startDataDateRange']?.errors?.[
              'dateInvalid'
            ] ||
            dataLogsFilterForm.controls?.['endDataDateRange']?.errors?.[
              'dateInvalid'
            ]
          ">
          Start data date cannot be greater than end data date.
        </p>
      </div>
    </div>
    <div class="drawer-footer">
      <button nz-button type="reset" nzType="default" (click)="reset()">
        Reset
      </button>
      <button
        nz-button
        type="button"
        nzType="primary"
        (click)="apply()"
        [disabled]="dataLogsFilterForm.invalid">
        Apply
      </button>
    </div>
  </form>
</nz-spin>
